'use strict';

// Cart drawer
(function() {
  const drawer  = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  const body    = document.getElementById('cart-body');
  const footer  = document.getElementById('cart-footer');
  const totalEl = document.getElementById('cart-total');
  const countEl = document.getElementById('header-cart-count');

  function open() { fetchCart().then(render); drawer.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function close() { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow = ''; }

  window.ogurOpenCart = open;

  document.querySelectorAll('#cart-toggle').forEach(btn => btn.addEventListener('click', open));
  document.getElementById('cart-close')?.addEventListener('click', close);
  overlay.addEventListener('click', close);

  async function fetchCart() { return (await fetch('/cart.js')).json(); }

  function fmt(cents) { return new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR',minimumFractionDigits:0}).format(cents/100); }

  function render(cart) {
    if (countEl) countEl.textContent = cart.item_count > 0 ? cart.item_count : '0';
    if (!cart.item_count) { body.innerHTML = '<p class="cart-empty">Votre panier est vide.</p>'; footer.style.display = 'none'; return; }
    footer.style.display = 'block';
    totalEl.textContent = fmt(cart.total_price);
    body.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <div class="cart-item__img">${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}</div>
        <div class="cart-item__details">
          <div>
            <p class="cart-item__title">${item.product_title}</p>
            <p class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
          </div>
          <div style="display:flex;justify-content:space-between;align-items:center">
            <span class="cart-item__price">${fmt(item.final_line_price)}</span>
            <button class="cart-item__remove" data-key="${item.key}">Retirer</button>
          </div>
        </div>
      </div>`).join('');
    body.querySelectorAll('.cart-item__remove').forEach(btn => {
      btn.addEventListener('click', async () => {
        await fetch('/cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:btn.dataset.key,quantity:0})});
        fetchCart().then(render);
      });
    });
  }

  fetchCart().then(cart => { if (countEl) countEl.textContent = cart.item_count || '0'; });
})();

// Mobile menu
(function() {
  const menuBtn = document.getElementById('mobile-menu-btn');
  const nav     = document.getElementById('mobile-nav');
  if (!menuBtn || !nav) return;

  menuBtn.addEventListener('click', () => {
    const isOpen = nav.classList.toggle('is-open');
    menuBtn.classList.toggle('is-open', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  // Close on link click
  nav.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => {
      nav.classList.remove('is-open');
      menuBtn.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

  // Mobile cart button
  document.getElementById('mobile-cart-toggle')?.addEventListener('click', () => {
    window.ogurOpenCart?.();
  });

  // Sync mobile cart count
  fetch('/cart.js').then(r => r.json()).then(cart => {
    const el = document.getElementById('mobile-cart-count');
    if (el) el.textContent = cart.item_count || '0';
  });
})();

// Sticky add to cart on mobile product page
(function() {
  const addBtn = document.getElementById('add-to-cart');
  if (!addBtn) return;
  if (window.innerWidth > 768) return;

  // Create sticky bar
  const sticky = document.createElement('div');
  sticky.className = 'mobile-sticky-cart';
  sticky.id = 'mobile-sticky-cart';

  const stickyAdd = document.createElement('button');
  stickyAdd.className = 'btn-cart';
  stickyAdd.textContent = 'Ajouter au panier';

  const shopPayOriginal = document.getElementById('shop-pay-btn');
  sticky.appendChild(stickyAdd);

  if (shopPayOriginal) {
    const stickyShopPay = shopPayOriginal.cloneNode(true);
    stickyShopPay.id = 'sticky-shop-pay';
    sticky.appendChild(stickyShopPay);
  }

  document.body.appendChild(sticky);

  // Show sticky when original button is out of view
  const observer = new IntersectionObserver(([e]) => {
    sticky.classList.toggle('is-visible', !e.isIntersecting);
  }, { threshold: 0 });
  observer.observe(addBtn);

  // Sync click
  stickyAdd.addEventListener('click', () => addBtn.click());
})();
